import { render, staticRenderFns } from "./receive-item-table.vue?vue&type=template&id=4996012c&scoped=true&"
import script from "./receive-item-table.vue?vue&type=script&lang=js&"
export * from "./receive-item-table.vue?vue&type=script&lang=js&"
import style0 from "./receive-item-table.vue?vue&type=style&index=0&id=4996012c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4996012c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4996012c')) {
      api.createRecord('4996012c', component.options)
    } else {
      api.reload('4996012c', component.options)
    }
    module.hot.accept("./receive-item-table.vue?vue&type=template&id=4996012c&scoped=true&", function () {
      api.rerender('4996012c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/receive-item-table.vue"
export default component.exports